import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Category from '../../entities/category';
import Task from '../../entities/task';
import TemplateTask from '../../entities/templateTask';
export function deleteCategory(category: Category, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = category.id;}
const _work = workingSet();
store.getState().tasks.getMappingFor('categories', category.id).filter(taskTemp => taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_task.categories = _task.categories?.filter(id => id !== category.id) || [];

_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
store.getState().templateTasks.getMappingFor('categories', category.id).filter(templateTaskTemp => templateTaskTemp.status !== 'D').forEach(templateTaskTemp => {
const _templateTask = ((_work.get('templateTask:' + templateTaskTemp.id) ?? templateTaskTemp) as TemplateTask).clone();
_templateTask.status = 'U';
_templateTask.addedOn = newHRTimestamp();
_templateTask.addedBy = getCurrentUserId();
_templateTask.importSource = targetImportSource;
_templateTask.importId = mergeId;
_templateTask.categories = _templateTask.categories?.filter(id => id !== category.id) || [];

_work.set('templateTask:' + _templateTask.id, _templateTask);
store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
});



category.status = 'D';
category.addedOn = newHRTimestamp();
category.addedBy = getCurrentUserId();
category.importSource = targetImportSource;
category.importId = mergeId;
store.dispatch(Actions.CategoryActions.removeCategoryQueue(category));
}
export function replaceCategory(category: Category, replaceWith: Category, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = category.id;}
const _work = workingSet();
store.getState().tasks.getMappingFor('categories', category.id).filter(taskTemp => taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_task.categories = _task.categories?.map(id => (id === category.id) ? replaceWith.id : id) || [];

_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
store.getState().templateTasks.getMappingFor('categories', category.id).filter(templateTaskTemp => templateTaskTemp.status !== 'D').forEach(templateTaskTemp => {
const _templateTask = ((_work.get('templateTask:' + templateTaskTemp.id) ?? templateTaskTemp) as TemplateTask).clone();
_templateTask.status = 'U';
_templateTask.addedOn = newHRTimestamp();
_templateTask.addedBy = getCurrentUserId();
_templateTask.importSource = targetImportSource;
_templateTask.importId = mergeId;
_templateTask.categories = _templateTask.categories?.map(id => (id === category.id) ? replaceWith.id : id) || [];

_work.set('templateTask:' + _templateTask.id, _templateTask);
store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
});



return category;
}
export function deleteImpactCategory(category: Category) {
const impacts: string[] = [];
const state = store.getState();
const taskCategoriesImpact = state.tasks.getMappingFor('categories', category.id).filter(task => task.status !== 'D');
taskCategoriesImpact.forEach(() => impacts.push('tasks'));
const templateTaskCategoriesImpact = state.templateTasks.getMappingFor('categories', category.id).filter(templateTask => templateTask.status !== 'D');
templateTaskCategoriesImpact.forEach(() => impacts.push('templateTasks'));



return util.countDistinct(impacts);
}
